<template>
  <div class="score-reason-chip">
    <vs-chip
      data-toggle="tooltip"
      data-placement="top"
      :title="getReasonDescription(reason)"
      @click.native="showDescription(reason)"
      class="cursor-pointer">{{reason}}</vs-chip>
  </div>
</template>

<script>
export default {
  name: "score-reason-chip",
  props: {
    reason: {
      type: String,
      required: true
    },
  },
  data: () => ({
    reasonDescriptions : {
      "A0": "Historial de pago de la cuenta es demasiado nuevo",
      "A1": "Último reporte de la Cuenta en estatus de morosidad",
      "A2": "Monto de crédito disponibles en cuentas revolventes",
      "A3": "Monto de deuda en cuentas es demasiado alto",
      "A4": "Monto de deuda en el banco/nacional en cuentas revolventes",
      "A5": "Monto de deuda clasificado en cobranza",
      "A6": "Monto de deuda en las cuentas morosas",
      "A7": "Monto de deuda en cuentas abiertas recientemente es demasiado alto",
      "A8": "Monto de deuda en cuentas revolventes abiertas recientemente de banco/nacionales es muy alta",
      "A9": 'Monto de deuda en cuentas abiertos recientemente en empresas de financiamiento al consumo es demasiado alto',
      "B0": 'Monto de deuda en cuentas de minoristas abiertas recientemente es demasiado alta',
      "B1": 'Monto de deuda en cuentas revolventes abiertas recientemente es demasiado alto',
      "B2": 'Monto de deuda en cuentas de empresas de financiamiento de ventas abiertas recientemente es muy alto',
      "B3": 'Monto de deuda en las cuentas de minoristas',
      "B4": 'Monto de deuda en cuentas revolventes',
      "B5": 'Monto de deuda en cuentas de crédito revolventes es demasiado alto',
      "B6": 'Montos en mora en cuentas',
      "D0": 'Declaración de quiebra reportada',
      "D1": 'Fecha de la última consulta muy reciente',
      "D2": 'Morosidad en las cuentas',
      "D3": 'Morosidad en cuentas abiertas recientemente',
      "D4": 'Eliminación de registro público o la cobranza reportada',
      "D5": 'La frecuencia de la morosidad',
      "D6": 'Nivel de morosidad en las cuentas',
      "D7": 'Morosidad grave',
      "D8": 'Morosidad grave, y registro público, o la cobranza reportada',
      "D9": 'Morosidad grave, registro público eliminado, o la cobranza reportada',
      "E0": 'Información Demográfica',
      "E1": 'Falta información demográfica',
      "E2": 'Número de consultas',
      "E3": 'Frecuencia de las consultas',
      "E4": 'La falta de información reciente de la cuenta',
      "E5": 'Monto de deuda en los registros públicos eliminados',
      "E6": 'Proporción del saldo sobre el límite de las cuentas',
      "F0": 'Historial de pagos disponible es insuficiente',
      "F1": 'Falta de cuentas de crédito de reciente creación',
      "F2": 'Falta de cuentas revolventes de reciente creación',
      "F3": 'Falta de información reciente de préstamo de autofinanciamiento',
      "F4": 'Falta de información reciente préstamo de auto',
      "F5": 'Falta de información reciente de banco/nacional revolvente',
      "F6": 'Falta de información reciente sobre cuentas de empresas de financiamiento al consumo',
      "F7": 'Falta de información reciente de préstamos',
      "F8": 'Falta de información reciente de préstamos hipotecarios',
      "F9": 'Falta de información reciente de préstamos no hipotecarios',
      "G0": 'Falta de información reciente de cuentas de minoristas',
      "G1": 'Falta de información reciente de cuentas revolventes',
      "G2": 'No hay créditos hipotecarios reportados',
      "G3": 'No hay información de saldos revolventes recientes de Bancos/Nacional',
      "G4": 'No hay información de saldos no hipotecarios recientes',
      "G5": 'No hay saldos de cuentas minoristas',
      "G6": 'No hay saldos revolventes recientes',
      "J0": 'Tiempo de Duración de las cuentas se han establecido',
      "J1": 'Tiempo de Duración de las cuentas de automóviles se han establecido',
      "J2": 'Tiempo de Duración de las cuentas revolventes del banco/nacionales se han establecido',
      "J3": 'Tiempo de Duración de los préstamos de compañías de financiamiento al consumo se han establecido',
      "J4": 'Tiempo de Duración de los préstamos a plazos se han establecido',
      "J5": 'Tiempo de Duración de las cuentas hipotecarias reportado se han establecido',
      "J6": 'Tiempo de Duración de los préstamos a plazos abiertos se han establecido',
      "J7": 'Tiempo de Duración de las cuentas de minoristas se han establecido',
      "J8": 'Tiempo de Duración de cuentas revolventes se han establecido',
      "J9": 'Tiempo transcurrido desde la actividad de la cuenta es demasiado largo',
      "K0": 'Tiempo transcurrido desde la Morosidad es demasiado reciente o desconocida',
      "K1": 'Tiempo transcurrido desde la eliminación del registro público o de la cobranza es demasiado corto',
      "K2": 'Tiempo transcurrido desde la apertura de la cuenta más reciente es demasiado corto',
      "K3": 'Tiempo transcurrido desde la más reciente apertura de cuenta automática es demasiado corto',
      "K4": 'Tiempo transcurrido desde la apertura de cuenta revolvente de banco/nacionales más reciente es demasiado corto',
      "K5": 'Tiempo transcurrido desde la apertura de cuenta de empresas de financiamiento de consumo más reciente es demasiado corto',
      "K6": 'Tiempo transcurrido desde la apertura de cuenta de préstamo a plazos más reciente es demasiado corto',
      "K7": 'Tiempo transcurrido desde la apertura de cuenta minorista más recientes',
      "K8": 'Tiempo transcurrido desde que se abrió la cuenta revolvente más reciente',
      "K9": 'Ha transcurrido muy poco tiempo desde que se abrió la cuenta más reciente de "sales finance"',
      "M0": 'Tiene un número de cuentas actualmente en impago',
      "M1": 'Número de cuentas "marcadas" con impago',
      "M2": 'Número de cuentas con impago reciente',
      "M3": 'Número de cuentas revolventes bancarias/nacionales activas',
      "M4": 'Número de cuentas activas de "retail"',
      "M5": 'Número de registros públicos adversos/derogados',
      "M6": 'Número de cuentas revolventes bancarias/nacionales con saldo',
      "M7": 'Número de cuentas revolventes bancarias/nacionales',
      "M8": 'Número de cuentas revolventes bancarias/nacionales u otras cuentas revolventes',
      "M9": 'Número de cobranzas registradas',
      "N0": 'Número de cuentas de "consumerfinancecompany" establecidas relativas a la longitud de la historia del consumidor',
      "N1": 'Número de consultas por compañías de financiamiento al consumo',
      "N2": 'Número de cuentas establecidas',
      "N3": 'Número de "open installmentloans"',
      "N4": 'Número de cuentas recientemente abiertas con compañías de financiamiento al consumo',
      "N5": 'Número de cuentas de "retail"',
      "N6": 'Número de cuentas de "retail" con saldo',
      "N7": 'Número de cuentas revolventes',
      "N8": 'Número de cuentas revolventes con saldos más altos que su límite',
      "P0": 'La proporción del saldo vs límite en las cuentas de préstamo automotriz es muy alta',
      "P1": 'La proporción del saldo vs límite en las cuentas con impago es muy alta',
      "P2": 'La proporción del saldo vs límite en las cuentas de financiamiento al consumo es muy alta',
      "P3": 'La proporción del saldo vs límite en las cuentas de "retail" es muy alta',
      "P5": 'La proporción del saldo vs el límite de crédito en cuentas revolventes nacionales o en otras cuentas revolventes es muy alta',
      "P6": 'La proporción del saldo vs límites de crédito en cuentas revolventes es muy alta',
      "P7": 'La proporción del saldo vs límite en "sales financecompany" es muy alta',
      "P8": 'La proporción del saldo vs el préstamo en créditos hipotecarios es muy alta',
      "P9": 'La proporción de saldo del préstamo vs la cantidad del préstamo es muy alta',
      "Q0": 'La proporción de saldos revolventes vs saldos totales es muy alta',
      "Q1": 'La proporción de saldos vs límites de créditos en las cuentas revolventes bancarias/nacionales es muy alta',
      "R0": 'Muy pocas cuentas han sido pagadas actualmente como fue convenido',
      "R1": 'Muy pocas cuentas con saldos',
      "R2": 'Muy pocas cuentas con información reciente de pagos',
      "R3": 'Muy pocas cuentas activas',
      "R4": 'Muy pocas cuentas revolventes bancarias/nacionales',
      "R5": 'Muy pocas cuentas revolventes bancarias/nacionales con información reciente de pagos',
      "R6": 'Muy pocas cuentas con compañías de financiamiento al consumo con información reciente de pagos',
      "R7": 'Muy pocas cuentas de "instalment"R8Muy pocas cuentas de "retail"',
      "R9": 'Muy pocas cuentas de "retail" con información reciente de pagos',
      "S0": 'Muy pocas cuentas revolventes',
      "S1": 'Muy pocas cuentas revolventes con información reciente de pagos',
      "S2": 'Muy pocas cuentas de "sales financecompany" con información reciente de pagos',
      "T0": 'Muchas cuentas abiertas recientemente',
      "T1": 'Muchas cuentas con saldos',
      "T2": 'Muchas cuentas revolventes bancarias/nacionales',
      "T3": 'Muchas cuentas de compañías financiamiento al consumo',
      "T4": 'Muchas cuentas de "instalment"',
      "T5": 'Muchas consultas en los últimos 12 meses',
      "T6": 'Muchas cuentas activas recientemente',
      "T7": 'Muchas cuentas de automóvil activas recientemente',
      "T8": 'Muchas cuentas revolventes bancarias/nacionales activas recientemente',
      "T9": 'Muchas cuentas de compañías financiamiento al consumo recientemente activas',
      "U0": 'Muchas cuentas de "instalment loan" recientemente activas',
      "U1": 'Muchas cuentas de "retail" recientemente activas',
      "U2": 'Muchas cuentas de "sales financecompany" recientemente activas',
      "U4": 'Muchas cuentas recientemente abiertas con saldos',
      "U5": 'Muchas cuentas revolventes bancarias/nacionales recientemente abiertas',
      "U6": 'Muchas cuentas de compañías de financiamiento al consumo recientemente abiertas',
      "U7": 'Muchas cuentas de "instalment" recientemente abiertas',
      "U8": 'Muchas cuentas de "retail" recientemente abiertas con saldos',
      "U9": 'Muchas cuentas revolventes recientemente abiertas',
      "V0": 'Muchas cuentas revolventes recientemente abiertas con saldos',
      "V1": 'Muchas cuentas de "sales financecompany" recientemente abiertasV2Muchas cuentas de "retail"',
      "V3": 'Muchas cuentas revolventes',
      "V4": 'Muchas cuentas revolventes bancarias/nacionales recientemente abiertas con saldos',
      "W3": 'Número de cuentas "subprime"',
      "W4": 'Falta de información de cargo reciente a tarjeta',
      "W5": 'Sin saldos de cargo a tarjeta recientes',
      "W6": 'Proporción de saldos vs límites de crédito en cuentas de "tarjetas de cargo" es muy alta',
      "W7": 'Sin saldos de cuenta recientesW8La proporción de "Cash Advances" vs el "Límite de Cash Advance" es muy alta',
      "W9": 'Cash Advance Activity on Accounts',
      "X0": 'Pagos pendientes en las cuentas',
      "C1": 'No existe el expediente.',
      "C2": "El expediente encontrado no tiene cuentas.",
      "C3": "El expediente encontrado está marcado como fallecido.",
      "C4": "El expediente encontrado no tiene cuantas activas en los últimos 24 meses.",
      "C5": "El expediente está marcado como fraudulento o sospechoso de fraude.",
      "SC": "No pudo calcularse score."
    }
  }),
  methods: {
    showDescription(reason) {
      swal("Información", this.getReasonDescription(reason), 'info');
    },
    getReasonDescription(reason) {
      return this.reasonDescriptions[reason] || "NA";
    }
  }
}
</script>
